import { z } from 'zod';
import { fileSchema } from '@wyz/utils';
import { RecordValues } from '@wyz/types';

export const JOBS_TYPES = {
  DISTRIBUTION_CUSTOMER_IMPORT: 'DISTRIBUTION_CUSTOMER_IMPORT',
  REDISTRIBUTION_CUSTOMER_IMPORT: 'REDISTRIBUTION_CUSTOMER_IMPORT',
  USER_IMPORT: 'USER_IMPORT',
  PROXIMITY_STOCKS_CUSTOMER_IMPORT: 'PROXIMITY_STOCKS_CUSTOMER_IMPORT',
} as const;

export const JOBS_ENDPOINT: Record<RecordValues<typeof JOBS_TYPES>, string> = {
  DISTRIBUTION_CUSTOMER_IMPORT: 'customers/import/distribution',
  REDISTRIBUTION_CUSTOMER_IMPORT: 'customers/import/redistribution',
  USER_IMPORT: 'users/import',
  PROXIMITY_STOCKS_CUSTOMER_IMPORT: 'customers/import/proximity-stocks',
} as const;

export const importForm = z.object({
  file: fileSchema,
});
